// Business contact information
export const PHONE_NUMBER = '9996212490';
export const PHONE_NUMBER_WITH_PREFIX = '+919996212490';

// Flexible cutoff times (used for step 2 meal selection)
export const LUNCH_CUTOFF_MINUTES = 12 * 60 + 30; // 12:30 PM = 750 minutes
export const DINNER_CUTOFF_MINUTES = 18 * 60 + 30; // 6:30 PM = 1110 minutes 18 * 60 + 30
export const LUNCH_CUTOFF_MINUTES_FOR_DISPLAY = "12:30 PM"; // 12:30 PM = 750 minutes
export const DINNER_CUTOFF_MINUTES_FOR_DISPLAY = "6:30 PM"; // 6:30 PM = 1110 minutes
export const LUNCH_DELIVERY_TIME = "12:00 PM - 2:00 PM";
export const DINNER_DELIVERY_TIME = "5:30 PM - 8:00 PM";

// WhatsApp configuration
export const WHATSAPP_DEFAULT_MESSAGE = 'Hi Shivay Durga Foods, \nI have a question about your menu and delivery options.';
export const getWhatsAppLink = (message = WHATSAPP_DEFAULT_MESSAGE) => {
  return `https://api.whatsapp.com/send?phone=91${PHONE_NUMBER}&text=${encodeURIComponent(message)}`;
};

export const CHOOSE_MENU_CONTEXT = "chooseMenu";